export default defineNuxtRouteMiddleware((to) => {
    // skip middleware on client side
    if (import.meta.client) return;

    const nuxtApp = useNuxtApp();
    const getRouteBaseName = useRouteBaseName();
    const routeName = getRouteBaseName(to);

    try {
        if (nuxtApp.$apm.currentTransaction && routeName && typeof routeName === "string") {
            nuxtApp.$apm.setTransactionName(routeName);
        }
    } catch (err) {
        console.error(err);
    }
});
